import React, { useState,
     useRef,
     useEffect
     }
from 'react';
import { LinearProgress, makeStyles } from '@material-ui/core';
import { api,
  PortalContext
} from '@portal/arq-portal-core';
import { Chat, Documento } from '../types';
import { postGD } from './helpers';
import Alert from '@material-ui/lab/Alert';
// import { findQueryKeyNoCaseSensitive } from './helpers';

const useStyles = makeStyles({
    chatContainer: {
      display: 'flex',
      flexDirection: 'column',
    //   height: '100%',
      height: 'calc(100vh - 70px)',
      maxWidth: '1000px',
      margin: '0 auto',
      backgroundColor: 'rgba(243, 243, 243, 0.9)',
      borderRadius: '10px',
      boxShadow: '0 0 10px rgba(0,0,0,0.1)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      position: 'relative',
      boxSizing: 'border-box',
    },
    header: {
      height: '60px',
      backgroundColor: '#DC0028',
      display: 'flex',
      alignItems: 'center',
      padding: '0 20px',
      boxSizing: 'border-box',
      color: 'white',
      fontSize: '1.2em',
      width: '100%',
      position: 'sticky',
      top: 0,
      left: 0,
      zIndex: 10,
    },
    profileImage: {
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      margin: '0 10px',
      objectFit: 'cover',
    },
    headerText: {
        fontFamily: "CO-Bold",
        fontSize: '22px'
    },
    userInput: {
        display: 'flex',
        alignItems: 'center',
        boxSizing: 'border-box',
        padding: '20px',
        borderRadius: '2px',
        fontSize: '14px',


    },
    textareaContainer: {
      position: 'relative',
      width: '100%',
      '& .messageInput': {
        flex: 1,
        padding: '15px',
        width: '97%',
        fontFamily: 'Catalana-sans, Arial, sans-serif !important',
        position: 'relative',
        minHeight: '80px',
        resize: 'none',
        border: 'none',
        borderBottom: '2px solid #ccc',
        overflow: 'hidden',
        borderRadius: '2px',
        fontSize: '14px',
        '&:focus': {
          outline: 'none',
          borderBottom: '2px solid #FF5e5e',
          boxShadow: 'none',
        },
      },
      '& .dragOver': {
        border: '2px dashed #ff7c7c !important',
       },
       '& .messageInput:disabled': {
        backgroundColor: '#ffffff !important', 
        cursor: 'not-allowed', 
        borderBottom: '2px solid #ddd !important',
        color: '#666 !important',
        opacity: 1,
      },
    },

    buttonsContainer: {
        position: 'absolute',
        right: '10px',
        display: 'flex',
        gap: '10px',
        top: 'calc(50% - 22px)',
        bottom: 'auto'
    },
    attachButton: {
      background: '#fefefe',
      border: 'none',
      cursor: 'pointer',
      borderRadius: '8px',
      padding: '8px',
      paddingBottom: '2px',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
      },
      pointerEvents: 'none',
      opacity: 0.3,
      transition: 'opacity 0.3s, cursor 0.3s',
      '&:hover$attachButtonEnabled': {
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
      },

    },
    attachButtonSvg: {
        width: '24px',
        height: '24px',
    },

    attachButtonEnabled: {
      pointerEvents: 'auto',
      opacity: 1,
      '& $attachButtonSvg': {
        // stroke: '#000', // Color when enabled
      },
  },

    sendButton: {
        background: '#fefefe',
        border: 'none',
        cursor: 'pointer',
        borderRadius: '8px',
        padding: '8px',
        paddingBottom: '2px',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
        },
        pointerEvents: 'none',
        opacity: 0.3,
        transition: 'opacity 0.3s, cursor 0.3s',
        '& :hover$sendButtonEnabled': {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
        },
    },
    sendButtonSvg: {
      width: '24px',
      height: '24px',
    },
    sendButtonEnabled: {
        pointerEvents: 'auto',
        opacity: 1,
        '& $sendButtonSvg': {
          stroke: '#000', // Color when enabled
        },
    },

    timestamp: {
      fontSize: '0.7em',
      color: '#777777',
    },

    inactivityLine: {
      width: '100%',
      height: '1px',
      background: '#ccc',
      margin: '20px 0',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    inactivityTimestamp: {
      position: 'absolute',
      background: '#f3f3f3',
      padding: '0 10px',
      fontSize: '0.8em',
      color: '#555',
    },
    fileInput: {
        display: 'none'
    },
    TemporaryTextArea:{
        backgroundColor: 'white',
        borderRadius: '10px',
        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
        width: '80%',
        maxWidth: '500px',
        padding: '20px',
        border: 'none',
        position: 'relative',
        fontFamily: 'Arial, sans-serif',
    },

    errorMessage:{
      display: 'flex',
      backgroundColor: 'white',
      borderRadius: '10px',
      boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
      width: '80%',
      maxWidth: '500px',
      padding: '20px',
      border: 'none',
      position: 'relative',
      fontFamily: 'Arial, sans-serif',

      '& .removeErrorMessage': {
        position: 'absolute',
        top: '-5px',
        right: '-5px',
        backgroundColor: 'red',
        color: 'white',
        borderRadius: '50%',
        width: '20px',
        height: '20px',
        textAlign: 'center',
        lineHeight: '20px',
        cursor: 'pointer',
        }
    },
    previewArea:{
        display: 'flex',
        flexWrap: 'wrap',
        padding: '20px',
        paddingBottom: '0',
        borderTop: '1px solid #eee',

        '&.disabled': {
          pointerEvents: 'none', // Bloquea interacciones
          opacity: 0.5, // Reduce visibilidad
          filter: 'grayscale(50%)', // (Opcional) Da una apariencia deshabilitada
        },

        '& .previewItem': {
            position: 'relative',
            marginRight: '10px',
            marginBottom: '10px',
        },
        '& .previewImage': {
        maxWidth: '100px',
        maxHeight: '100px',
        borderRadius: '5px',
        },
        '& .previewFile': {
        padding: '5px 10px',
        backgroundColor: '#ff7c7c',
        borderRadius: '5px',
        fontSize: '0.8em',
        },
        '& .removePreview': {
        position: 'absolute',
        top: '-5px',
        right: '-5px',
        backgroundColor: '#f1d4d4',
        color: '#b91e1e',
        borderRadius: '50%',
        width: '20px',
        height: '20px',
        textAlign: 'center',
        lineHeight: '20px',
        cursor: 'pointer',

        '&:hover': {
          backgroundColor: '#e0b3b3',
        },

        '&.disabled': {
            cursor: 'not-allowed',
            backgroundColor: '#ddd',
            color: '#aaa',
        },
        },
    },
    chatMessages: {
        flex: 1,
        overflowY: 'auto',
        padding: '20px',
        marginTop: '10px',
        boxSizing: 'border-box',
        position: 'relative',

        '& *': {
        //   fontFamily: '"CatalanaSans"',
          fontSize: '14px',
          color: '#000',
        },

        '& messageContainer': {
            display: 'flex',
            alignItems: 'flex-start',
            marginBottom: '10px',
        },

        '& .message': {
          display: 'inline-block',
          padding: '10px',
          borderRadius: '20px',
          marginBottom: '10px',
          maxWidth: '80%',

            '& .messageContent p:empty': {
                display: 'none',
            },
            '& .timestamp': {
                fontSize: '10px',
                color: '#505050',
            },
        },
        '& .inactivityLine':{
            fontSize: '10px',
            color: '#505050',
            width: '100%',
            height: '1px',
            background: '#ccc',
            margin:' 20px 0',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '& .timestamp': {
                fontSize: '10px',
                color: '#505050',
                position: 'absolute',
                background: '#f3f3f3',
                padding: '0 10px',
            },
        },

        '& .messageContent p': {
            margin: '0 0 10px 0'
        },

        '& .messageContent pre': {
            backgroundColor: '#f4f4f4',
            border: '1px solid #ddd',
            borderRradius: '3px',
            padding: '10px',
            overflowX: 'auto',
            whiteSpace: 'pre-wrap'
        },

        '& .messageContent code' :{
            backgroundColor: '#f4f4f4',
            borderRadius: '3px',
            padding: '2px 4px',
            fontFamily: 'monospace'
        },

        '& .messageContent blockquote': {
          padding: '2px 10px',
          borderRadius: '2px',
          border: '1px solid #DDD',
          borderLeft: '4px solid #DDD !important',
        },

        '& .messageContent table': {
            borderCollapse: 'collapse'
        },

        '& .messageContent th, .messageContent td': {
            border: '1px solid #ddd',
            padding: '5px'
        },

        '& .messageContent img': {
          // maxWidth: '100%',
          maxWidth: '200px',
          maxHeight: '200px',
          // borderRadius: '5px',
          border: '1px solid rgb(230, 230, 230)',
        },
        '& .messageContent a': {
          color: '#DC0028',
          '&:hover': {
            color: '#B7788F',
          },
        },
        '& .botMessage': {
            alignSelf: 'flex-start',
            backgroundColor: 'transparent',
            color: 'black',
            borderRadius: '20px',
            margin: '5px 0',
            maxWidth: '100%',
            wordWrap: 'break-word',
            display: 'inline-block',
            position: 'relative',
            padding: '0px',
            marginTop: '0px',

          '& .messageContent': {
            backgroundColor: '#FFF',
            padding: '10px 10px 0px',
            borderRadius: '2px',
            border: '1px solid rgb(230, 230, 230)',
            marginBottom: '6px',
          },
        },

        '& .messageWrapper':{
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'row'
        },

        '& .userMessageWrapper': {
          flexDirection: 'row-reverse',
          width: '100%',
          justifyContent: 'flex-start',
        },
        '& .userMessage': {
            alignSelf: 'flex-end',
            backgroundColor: 'transparent',
            color: 'black',
            borderRadius: '20px',
            maxWidth: '100%',
            margin: '5px 0',
            wordWrap: 'break-word',
            display: 'inline-block',
            position: 'relative',

            padding: '0px',
            marginTop: '0px',

          '& .messageContent': {
            backgroundColor: '#FFF',
            padding: '10px 10px 0px',
            borderRadius: '2px',
            border: '1px solid rgb(230, 230, 230)',
            marginBottom: '6px',
          },
        },
        '& .message.userMessage .timestamp': {
          textAlign: 'right',
        },
    },
    loadingDots: {
        textAlign: 'center',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        marginTop: '10px',
        marginBottom: '10px',
        '& div':{
            width: '8px',
            height: '8px',
            margin: '0 2px',
            backgroundColor: '#ff7c7c',
            borderRadius: '50%',
            animation: '$loading 2.2s infinite ease-in-out',

            '&:nth-child(2)': {
                animationDelay: '0.2s',
              },
            '&:nth-child(3)': {
                animationDelay: '0.4s',
            },
        }
    },
    '@keyframes loading': {
        '0%, 100%': {
          opacity: 0,
        },
        '50%': {
          opacity: 1,
        },
      },

    aviso: {
      margin: '0 20px 0 20px',
      color: '#b91e1e',
      backgroundColor: '#f1d4d4',
      borderRadius: '0px',
      fontSize: '14px',
      borderLeft: '5px solid #b91e1e',
      paddingLeft: '10px',
      fontFamily: 'Catalana-sans',
      '& .MuiAlert-icon': {
          display: 'none',
      },
      '& .MuiAlert-message': {
          padding: '0px',
          display: 'flex',
          alignItems: 'center',
      }, 
      '& i': {
          marginRight: '5px',
          fontSize: '28px'
      }
    },
    progressingBar:{
      marginTop: '-8px'
    }
  });

export const ChatbotGepetto = (
  //props:any
  ) => {
  const classes = useStyles();
  const { user } = React.useContext(PortalContext);

//   const messageInputRef = useRef<HTMLTextAreaElement | null>(null);
const [messages, setMessages] = useState<any>([]);
const [isEnabled, setIsEnabled] = useState(false);
const textareaRef = useRef<HTMLTextAreaElement | null>(null);
const fileInputRef = useRef<HTMLInputElement | null>(null);
const chatMessagesRef = useRef<HTMLDivElement | null>(null); // Referencia al contenedor de mensajes
const [previews, setPreviews] = useState<any[]>([]); // Estado para previsualizaciones
const [isLoading, setIsLoading] = useState(false); // Estado inicial: no cargando
const [isDragOver, setIsDragOver] = useState(false); // Estado para manejar drag-over
const [isProcessing, setIsProcessing] = useState(false); // Estado inicial: no cargando
const [errorMessage, setErrorMessage] = useState(""); // Nuevo estado para manejar el error en la subida
// const [inactivityTimeout, setInactivityTimeout] = useState<NodeJS.Timeout | null>(null);

const idConversacionRef= useRef<string | null>(null);
const userFoto = user?.foto !== null ? api.getApiServer() + user?.foto : "";

// var queryUser = findQueryKeyNoCaseSensitive('user');
// var userId = queryUser ?? props.user ?? user?.id;



// const resetInactivityTimer = () => {
//     if (inactivityTimeout) {
//       clearTimeout(inactivityTimeout);
//     }

//     // Configurar el temporizador de inactividad
//     const timeout = setTimeout(() => {
//       addMessage('', false,true); // Agregar línea de inactividad
//     }, 1 * 60 * 1000); // 1 minuto

//     setInactivityTimeout(timeout);
//   };

  const handleInputChange = (e:any) => {
      setIsEnabled(e.target.value.trim().length > 0); // Habilitar si hay texto
    };

  const handleAttachClick = () => {
      if (fileInputRef.current) {
          fileInputRef.current.click(); // Disparar el clic en el file input
      }
  };



  // const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "application/pdf"];
  const allowedTypes = ["image/jpeg", "image/jpg"];
  const processFiles = (files: FileList) => {
    const filteredFiles = Array.from(files).filter((file) => allowedTypes.includes(file.type));
    
    if (filteredFiles.length === 0) {
      alert("Solo se permiten archivos JPG/JPEG.");
      return;
    }

    const newPreviews = filteredFiles.map((file) => {
      if (file.type.startsWith('image/')) {
        return {
          type: 'image',
          file,
          preview: URL.createObjectURL(file),
        };
      } else {
        return {
          type: 'file',
          file,
          preview: file.name,
        };
      }
    });
    setPreviews((prev) => [...prev, ...newPreviews]);
  };

  // Manejar el evento de cambio de archivos (onChange)
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files) {
      processFiles(files);
    }
  };

  // Manejar el evento de arrastrar y soltar (onDrop)
  const handleDrop = (e: React.DragEvent<HTMLTextAreaElement>) => {
    e.preventDefault();
    setIsDragOver(false); // Desactivar estado de drag-over
    const files = e.dataTransfer.files; // Obtener archivos desde el evento de drop
    processFiles(files);
    // Sincronizar archivos con fileInputRef
    if (fileInputRef.current) {
        const dataTransfer = new DataTransfer();
        // Mantener archivos previos
        Array.from(fileInputRef.current.files || []).forEach((file) => {
        dataTransfer.items.add(file);
        });
        // Agregar nuevos archivos
        Array.from(files).forEach((file) => {
        dataTransfer.items.add(file);
        });
        fileInputRef.current.files = dataTransfer.files;
    }
  };

  const handleDragLeave = (e: React.DragEvent<HTMLTextAreaElement>) => {
    e.preventDefault();
    setIsDragOver(false); // Desactivar estado de drag-over
  };

  const handleDragOver = (e: React.DragEvent<HTMLTextAreaElement>) => {
    e.preventDefault(); // Evitar comportamiento predeterminado (abrir archivo)
    if(!isDragOver){
        setIsDragOver(true); // Activar estado de drag-over
    }
  };


  // Remover una previsualización
  const removePreview = (index: number) => {
    setPreviews((prev) => prev.filter((_, i) => i !== index));
    if (fileInputRef.current) {
      const dataTransfer = new DataTransfer();
      Array.from(fileInputRef.current.files || []).forEach((file, i) => {
        if (i !== index) {
          dataTransfer.items.add(file);
        }
      });
      fileInputRef.current.files = dataTransfer.files;
    }
  };

  // Remover mensajeError
  const removeErrorMessage = () =>{
    setErrorMessage('');
  }

  useEffect(() => {
    // Load initial bot message
    addMessage('Hola, soy el asistente virtual de resolución de incidencias de Occident. Si tienes alguna incidencia, por favor trata de describirla lo mejor posible, y en caso de que sea posible, adjunta capturas de pantalla o archivos que puedan ayudar a entender mejor el problema.\n\nEn caso de no poder ayudarte, abriré un ticket para que un técnico te ayude lo antes posible.\n', false);
    // addMessage(
    //     "<p>Voy a proceder a contactar con un t\u00e9cnico para que trate de resolver tu incidencia. He generado el siguiente resumen: </p>\n\n<blockquote>\n  <p>El usuario ha intentado conectarse, pero no ha logrado establecer la conexi\u00f3n. Mencion\u00f3 que ya ha verificado los pasos necesarios, pero el problema persiste. No se han proporcionado detalles adicionales sobre el tipo de conexi\u00f3n (Wi-Fi, VPN, servidor, etc.) ni sobre los mensajes de error que puedan estar apareciendo. Es necesario investigar m\u00e1s a fondo para identificar la causa del problema.</p>\n</blockquote>\n\n<p>Por favor, ind\u00edcame si es correcto y si quieres que genere la incidencia. En caso contrario, reescribe el resumen para proporcionar toda la informaci\u00f3n que consideres necesaria.</p>\n",
    //     false
    //   );
}, []);

  useEffect(() => {
    const textarea = textareaRef.current;

    if (!textarea) return; // Early return if the textarea is null

    const handleKeyDown = (e:any) => {
      if (e.ctrlKey && e.key === 'Enter') {
        e.preventDefault(); // Prevent the default action (e.g., form submission)
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        textarea.value =
          textarea.value.substring(0, start) + "\n" + textarea.value.substring(end);
        textarea.selectionStart = textarea.selectionEnd = start + 1; // Move the cursor to the next line
      } else if (e.key === 'Enter') {
        // Enter: Enviar mensaje
        e.preventDefault();
        sendMessage();
      }
    };

    textarea.addEventListener('keydown', handleKeyDown);

    return () => {
      textarea.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    const chatContainer = chatMessagesRef.current;
    if (chatContainer) {
      chatContainer.scrollTop = chatContainer.scrollHeight;
    }
  }, [messages]); // Dependencia en los mensajes


    const addMessage = (content:string, isUser:boolean, isInactivityLine:boolean = false) => {
        if (isInactivityLine) {
            // Crear contenido especial para la línea de inactividad
            const inactivityLine = (
              <div className="inactivityLine">
                <div className="timestamp">
                  {'SESIÓN CADUCADA'}
                  {/* {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} */}
                </div>
              </div>
            );

            setMessages((prev:any) => [
              ...prev,
              {
                isUser: null,
                content: [inactivityLine], // Contenido especial
                timestamp: null, // Sin timestamp normal
              },
            ]);
            return;
          }

        const processedMessage = content.replace(/\n/g, "<p> </p>");
        // console.log(processedMessage);
        const parsedContent = processedMessage

        // const parsedContent = content.split('\n').map((line, index) => {
        //     if (line.startsWith('<img src="') && line.endsWith('"')) {
        //         const src = line.slice(10, -1); // Extraer el contenido entre <img src=" y ">
        //         return <img key={index} src={src} alt={`img-${index}`} />;
        //     } else {
        //         // Parsear contenido HTML usando html-react-parser
        //         return <div key={index}>{parse(line)}</div>;
        //     }
        // });

        // const parsedContent = content.split('\n').map((line, index) => {
        //     if (line.startsWith('<img src="') && line.endsWith('">')) {
        //       // Extraer el src de la imagen
        //       const src = line.match(/<img src="(.+?)"/)?.[1];
        //       if (src) {
        //         return <img key={index} src={src} alt="message attachment" className="messageImage" />;
        //       }
        //     }
        //     // Devolver texto envuelto en <p>
        //     return (
        //       <p key={index}>
        //         {line}
        //       </p>
        //     );
        //   });

        setMessages((prev:any) => [
        ...prev,
        {
            isUser,
            content: parsedContent,
            timestamp: new Date().toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
                }),
        },
        ]);
    };

    const sendMessage = async () => {
      if(errorMessage) setErrorMessage('');
      setIsLoading(true);
      setIsProcessing(true);

      if (!textareaRef.current && previews.length === 0) {
        setIsLoading(false);
        setIsProcessing(false);
        return
      }

      let messageText = textareaRef.current?.value.trim() || '';
      const files = fileInputRef.current?.files;

      if (!messageText && previews.length === 0) {
        console.warn('No se puede enviar un mensaje vacío.');
        setIsLoading(false);
        setIsProcessing(false);
        return;
      }

      let displayContent = messageText.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;") + "\n";

      let attachments: Documento[] = [];
      if (files) {
        let serviceEndpoint = "/gd/";
        for (const file of Array.from(files)) {
          const formData = new FormData();
          formData.append('file', file);  
          try {
            const data = await postGD(serviceEndpoint, formData);
            console.log("Upload Success:", data);
            attachments.push({ id: data.id });
            if (file.type.startsWith('image/')) {
              displayContent += `\n<img src="${URL.createObjectURL(file)}" class="message-image" alt="${file.name}" />`;
            } else {
              displayContent += `\nAdjunto: ${file.name}`;
            }
          } catch (error) {
            console.error("Upload Error:", error);
            setErrorMessage(`Disculpa ha surgido un error al enviar la imagen "${file.name}". Inténtalo de nuevo.`);
            setIsProcessing(false);
            setIsLoading(false);
            return 
          }
        }
      }

      addMessage(displayContent, true);

      // Limpiar el textarea y las previsualizaciones
      if (textareaRef.current) {
        textareaRef.current.value = '';
      }
      setPreviews([]);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }

      setIsEnabled(false);
      const service = "/be/chatbot/";
      let requestBody: {Entrada:Chat} = {
        Entrada:{
          consultaUsuario: messageText? messageText: null, // Texto del usuario
          idConversacion: idConversacionRef.current , // ID de la conversación
          attachments: attachments.length > 0 ? attachments : null // Documentos adjuntos
        }
      };

      console.log("JSON enviado al backend:", JSON.stringify(requestBody));
        api.post(service, requestBody).then((data:any) => {
          // console.log(data);
          if(data?.Retorno?.Codigo == 0 && data.Salida.Respuesta != null && data.Salida.Respuesta != "") {
            if(data.Salida.idConversacion != null && data.Salida.idConversacion != ""){
              idConversacionRef.current = data.Salida.idConversacion;
            }
            addMessage(data.Salida.Respuesta + "\n", false);
            if(data.Salida.endSession == true){
              idConversacionRef.current = null;
              addMessage('', false,true); // Agregar línea de inactividad
            }
          }
          else {
            throw Error(data.Retorno.Codigo?.Descripcion)
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          addMessage(
            'Disculpa, ha habido un error procesando tu petición. Inténtalo de nuevo.\n',
            false
          );
        }).finally(()=>{
          setIsProcessing(false);
          setIsLoading(false);
        });
      // resetInactivityTimer(); // Reiniciar el temporizador
    };

  return (
    <div className={classes.chatContainer}>
        <div className={classes.header}>
            <img src="/assets/chatbot-icon.png" alt="Profile Image" className={classes.profileImage}/>
            <div className={classes.headerText}>Asistente de incidencias</div>
        </div>
        <div className={classes.chatMessages} ref={chatMessagesRef}>
            {messages.map((msg:any, index:any) => (
                msg.isUser == null && msg.timestamp == null ? <div key={index}> {msg.content}</div>:
                    <div key={index} className="messageContainer">
                    <div className={ `messageWrapper  ${msg.isUser ? "userMessageWrapper" : ""}`}>
                        <img src={`${msg.isUser ? userFoto :"/assets/chatbot-icon.png"}`} className={classes.profileImage} />
                        <div className={`message  ${msg.isUser ? "userMessage" : "botMessage"}`}>
                            <div className="messageContent" dangerouslySetInnerHTML={{ __html:msg.content}}></div>
                            <div className="timestamp">{msg.timestamp}</div>
                        </div>
                    </div>
                </div>
                ))}
            {/* <!-- Messages will be added here dynamically --> */}
            {/* <!-- LOADING INDICATOR DOTS --> */}
            {isLoading && <div id="loading-indicator" className={classes.loadingDots}>
                <div></div>
                <div></div>
                <div></div>
            </div>}
            {/* <!-- LOADING INDICATOR DOTS --> */}

        </div>

        {/* <!-- Temporary Text Area --> */}
        <dialog className={classes.TemporaryTextArea}
        >
            <form method="dialog">
                <h3>Información</h3>
                <div>
                    <label>Mensaje del sistema: Se está generando su ticket informático. Por favor, manténgase a la espera.</label><br/>
                </div>
                <div className={classes.loadingDots}
                // className={classes.loadingDots+" "+ classes.loadingIndicator}
                >
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </form>
        </dialog>

      
        {errorMessage && <Alert className={classes.aviso} onClose={() => removeErrorMessage()}>
              <i className='icon-error-fixed'></i>
              <span>{errorMessage}</span>
          </Alert>
        }

        {previews.length > 0 && <div className={`${classes.previewArea} ${isProcessing ? 'disabled' : ''}`}>
          {previews.map((preview, index) => (
          <div key={index} className={`previewItem`} >
              {preview.type === 'image' ? (
              <img src={preview.preview} alt="preview" className="previewImage" />
              ) : (
              <div className="previewFile">{preview.preview}</div>
              )}
              <div className={`removePreview ${isProcessing ? 'disabled' : ''}`} onClick={() => !isProcessing && removePreview(index)}>
              x
              </div>
          </div>
          ))}
        </div>}

        <div className={classes.userInput} >
            <input type="file"
                ref={fileInputRef}
                className={classes.fileInput}
                multiple
                style={{display: "none"}}
                onChange={handleFileChange}
                accept=".jpg"
            />

            <div className={classes.textareaContainer}>
                <textarea ref={textareaRef}
                    onChange={handleInputChange}
                    onDrop={handleDrop} // Manejar archivos soltados
                    onDragLeave={handleDragLeave} // Desactivar drag-over
                    onDragOver={handleDragOver} // Permitir arrastrar sobre el textarea
                    className={`messageInput ${isDragOver ? 'dragOver' : ''}`}
                    placeholder="Escriba su mensaje..." rows={3}
                    disabled={isProcessing}
                    ></textarea>
                {isProcessing && <div className={classes.progressingBar}><LinearProgress color="primary" /></div>}
                <div className={`${classes.buttonsContainer} `} >
                    <button
                        className={`${classes.attachButton} ${!isProcessing? classes.attachButtonEnabled : ''}`}
                        aria-label="Attach"
                        onClick={handleAttachClick}
                        disabled={isProcessing}
                    >
                        <svg className={classes.attachButtonSvg} viewBox="0 0 24 24" fill="none" xmlns="https://gestionanuevo.gco.globalwww.w3.org/2000/svg">
                            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                                <path d="M16.617 14.496a1 1 0 0 1 1.414 1.414l-3.182 3.182a7 7 0 1 1-9.9-9.9l5.658-5.656a5 5 0 1 1 7.07 7.07l-5.656 5.658a3 3 0 0 1-4.243-4.243l4.596-4.596a1 1 0 1 1 1.415 1.414l-4.597 4.596a1 1 0 1 0 1.415 1.414l5.656-5.657a3 3 0 1 0-4.242-4.242l-5.657 5.657a5 5 0 1 0 7.071 7.07l3.182-3.181z" fill="#000000"></path>
                            </g>
                        </svg>
                    </button>
                    <button className={`${classes.sendButton} ${isEnabled && !isProcessing ? classes.sendButtonEnabled : ''}`}
                            aria-label="Send"
                            onClick={sendMessage}
                            disabled={!isEnabled || isProcessing } // Deshabilitar si no hay texto
                    >
                        <svg className={classes.sendButtonSvg} viewBox="0 0 24 24" fill="none" xmlns="https://gestionanuevo.gco.globalwww.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier">
                                <path d="M10.3009 13.6949L20.102 3.89742M10.5795 14.1355L12.8019 18.5804C13.339 19.6545 13.6075 20.1916 13.9458 20.3356C14.2394 20.4606 14.575 20.4379 14.8492 20.2747C15.1651 20.0866 15.3591 19.5183 15.7472 18.3818L19.9463 6.08434C20.2845 5.09409 20.4535 4.59896 20.3378 4.27142C20.2371 3.98648 20.013 3.76234 19.7281 3.66167C19.4005 3.54595 18.9054 3.71502 17.9151 4.05315L5.61763 8.2523C4.48114 8.64037 3.91289 8.83441 3.72478 9.15032C3.56153 9.42447 3.53891 9.76007 3.66389 10.0536C3.80791 10.3919 4.34498 10.6605 5.41912 11.1975L9.86397 13.42C10.041 13.5085 10.1295 13.5527 10.2061 13.6118C10.2742 13.6643 10.3352 13.7253 10.3876 13.7933C10.4468 13.87 10.491 13.9585 10.5795 14.1355Z" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                            </g>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>
  );
};


